import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReportEntity } from 'src/app/reports/components/report/models/report-entity.model';
import { IRteListButtonItem } from 'rte-library';
import { Entity } from 'src/app/reports/components/entity/entity.model';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  selector: 'app-add-entity',
  templateUrl: './add-entity.component.html',
  styleUrls: ['./add-entity.component.scss']
})
export class AddEntityComponent extends BaseComponent implements OnInit {

  //#region Inputs

  @Input() entities: Array<ReportEntity>;
  @Input() disabled: boolean;

  //#endregion

  //#region Outputs

  @Output() onSelected: EventEmitter<Entity> = new EventEmitter<Entity>();
  @Output() onAdd: EventEmitter<ReportEntity> = new EventEmitter<ReportEntity>();

  //#endregion

  //#region Properties

  isActive = false;
  page = 1;

  disable = true;

  entityId: number;
  alias: string;

  //#endregion

  //#region Ctor

  constructor() {
    super();
  }

  //#endregion

  //#region Interface Implementations

  ngOnInit() { }

  //#endregion

  //#region Methods

  clearFields() {
    this.entityId = 0;
    this.alias = '';
  }

  getEntityById(id: number ): ReportEntity {
    return this.entities.find(item => {
      return item.EntityId === id;
    });
  }

  //#endregion

  //#region Events

  onConfirm() {
    if (this.entityId) {
      const entity = this.getEntityById(this.entityId);

      if (entity) {
        if (this.alias) {
          entity.Alias = this.alias;
        } else {
          entity.Alias = entity.Entity.Description;
        }
        this.onAdd.emit(entity);
        this.closePopover();
      }
    }
  }

  closePopover() {
    this.isActive = false;
    this.clearFields();
  }

  onEntityChange(value: Entity) {
    this.disable = !value;
    this.onSelected.emit(value);
  }

  onAddClick(event) {
    this.isActive = !this.isActive;
    this.disable = true;
  }
  //#endregion

  //#region Validations

  getEntityErrorMessage() {
    return !this.entityId ? 'Por favor, selecione uma entidade' : '';
  }

  //#endregion
}
